import { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import usePortal from 'react-cool-portal';
import InputMask from 'react-input-mask';
import DatePickerWrapper from '../DatePickerWrapper';
import calendar from '../../../assets/images/calendar-month.svg';
import { ReactComponent as CrossIcon } from '../../../assets/images/cross.svg';
import Picker from './picker';

const DoubleRangeDatePicker = ({
  value,
  inputValue,
  onChange,
  changeInputValue,
  customRef,
  clearCallback,
  left,
  oneSide
}) => {
  const [position, setPosition] = useState();

  const { Portal, isShow, show, hide } = usePortal({
    defaultShow: false,
    onShow: e => {
      e.persist();
      const bodyRect = document.body.getBoundingClientRect();
      const { target } = e;
      const el = target?.alt === 'calendar' ? target.parentNode : target;
      const elemRect = el.getBoundingClientRect();
      const offset = elemRect.top - bodyRect.top;
      const { left: newLeft } = elemRect;
      if (left) {
        const right = newLeft - 555;
        setPosition({ top: `${offset + 38}px`, left: `${right}px` });
      } else {
        setPosition({ top: `${offset + 38}px`, left: `${newLeft}px` });
      }
    }
  });

  const enterPress = e => {
    const { key } = e;
    if (key === 'Enter') hide();
  };

  useEffect(() => {
    document.addEventListener('keydown', enterPress);
    return () => document.removeEventListener('keydown', enterPress);
  }, []);

  const clearDates = callTop => {
    // setState({
    //   startDate: null,
    //   endDate: null,
    //   focusedInput: START_DATE,
    //   inputValue: '',
    //   error: false
    // });
    hide();
    if (callTop) {
      clearCallback();
    }
  };

  return (
    <DatePickerWrapper>
      <div className="datepicker-block">
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <button ref={customRef} className="clearValues d-none" type="button" onClick={clearDates} />
        <InputMask
          className={`single-input${value.error ? ' error' : ''}`}
          mask="99/99/9999 - 99/99/9999"
          placeholder="Select the dates"
          value={inputValue}
          onChange={changeInputValue}
          onKeyPress={enterPress}
          onClick={show}
        />
        {value.startDate && value.endDate ? (
          <CrossIcon className="icon" width={20} height={20} onClick={() => clearDates(true)} />
        ) : (
          // eslint-disable-next-line
          <img className="icon" src={calendar} alt="calendar" onClick={show} />
        )}
        <Portal>
          <div
            className={`pickers z-9999${isShow ? ' show ' : ' '}range ${left ? 'left' : ''}`}
            style={position}
          >
            <Picker value={value} handleDateChange={onChange} />
            {!oneSide && (
              <>
                <div className="h-divider" />
                <Picker value={value} handleDateChange={onChange} />
              </>
            )}
          </div>
        </Portal>
      </div>
    </DatePickerWrapper>
  );
};

DoubleRangeDatePicker.propTypes = {
  changeInputValue: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  customRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  left: PropTypes.bool,
  clearCallback: PropTypes.func,
  inputValue: PropTypes.string,
  value: PropTypes.instanceOf(Object).isRequired,
  oneSide: PropTypes.bool
};

DoubleRangeDatePicker.defaultProps = {
  customRef: null,
  left: false,
  clearCallback: () => {},
  inputValue: '',
  oneSide: false
};

export default DoubleRangeDatePicker;
